<ng-template #analysisOptionsDialog >
      <div style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
          <button class="close-button" mat-dialog-close >
            <img src="./assets/images/close-icon.svg">
          </button>
      </div>
  
    
    <mat-dialog-content class="box-content">
        <div class="main-box-title-32" style="margin-bottom: 20px ;"> Analysis Options</div>
        <div class="main-box-title-18" style="margin-bottom: 20px ;"> Choose the correct settings below for better results.</div>
        <div class="box-types">
          <div class="select-container">
            <label for="englishType">English type</label>
            <select id="englishType" name="englishType" class="custom-select" (change)="onEnglishTypeChange($event)">
              <option value="british">British English</option>
              <option value="american">American English</option>
            </select>
          </div>
          
        </div>

        <div class="box-types">
          <div class="select-container">
            <label for="analysisMode">Analysis mode</label>
            <select id="analysisMode" name="analysisMode" class="custom-select" (change)="onAnalysisModeChange($event)">
              <option value="Writing">Writing</option>
              <option value="Reading">Reading</option>
              <option value="Listening">Listening</option>
            </select>
          </div>
        </div>
        
        <div class="box-types">
          <div class="select-container">
            <label for="targetCEFR">Target overall CEFR Score for your text</label>
            <select id="targetCEFR" name="targetCEFR" class="custom-select" (change)="onTargetCEFRChange($event)">
              <option value="A1">A1</option>
              <option value="A2">A2</option>
              <option value="B1">B1</option>
              <option value="B2">B2</option>
              <option value="C1">C1</option>
              <option value="C2">C2</option>
            </select>
          </div>
        </div>
        
        <button class="main-box-value-14 button-settings" [ngClass]="{'expanded': isExpanded}" (click)="toggleExpand()">Advanced Settings <mat-icon class="expand-icon" style="order:3;">expand_more</mat-icon></button>
         
        <div *ngIf="isExpanded" class="box-expanded-advanced">
           <div class="box-slip-documents">
            <span for="sizeType">Split documents at this character
              <div class="tooltip-container">
              <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
              <span class="tooltip-text" >You can input multiple texts into Text Inspector. This option allows you to choose which character serves as a delimiter between each text.</span>
            </div></span>
  
           <div class="custom-text-container">
            <input type="text" id="customInput" class="custom-text-input" [(ngModel)]="splitCharacter" (change)="onSplitCharacterChange($event)">
          </div>
          </div>
          <mat-checkbox color="accent"  [checked]="true" (change)="onExcludeDigitsChange($event)" disableRipple>Exclude all digits</mat-checkbox>
          <ng-container *ngIf="isScreenLarge; else mobileLayout">
            <div class="horizontal-box" style="  border: none; padding: 0px; margin-bottom: 0px;">
              <mat-checkbox color="accent"  [checked]="true" (change)="onUseKnownWordsChange($event)" style="margin-right: 10px;" disableRipple>Use known words list</mat-checkbox>
              
                <div style="margin-right: 10px;" >
                  <select id="listSelect" name="listSelect" class="custom-select" [(ngModel)]="wordlistselect" style="width: 120px; margin-bottom: 0px;" (change)="onWordlistChange($event)"> 
                    <option *ngFor="let lista of nombresListas" [value]="lista.id">{{ lista.nombre }}</option>
                  </select>
                </div>
              
             
                <span style="margin-left: 10px; color: #EEA21A; cursor: pointer; font-weight: 580;"><u style="margin-right: 5px;" (click)="createList()">Create New Known Word List</u><div class="tooltip-container">
                  <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                  <span class="tooltip-text2" >
You can create a new set of 'known words' which will be ignored in analysis. This is particularly useful if your text is domain-specific, and certain specific terminology is overrepresented compared to the normal population. For example, if you are teaching a group of doctors who will be more familiar with complex medical terms than the average person. </span>
                </div></span>
            </div>
          </ng-container>

          <!----------->
          <!-- MOBIL -->
          <!----------->

          <ng-template #mobileLayout>
            
              <mat-checkbox color="accent"  [checked]="true" (change)="onUseKnownWordsChange($event)" style="margin-right: 10px;" disableRipple>Use known words list</mat-checkbox>


                <div style="text-align: center; align-items: center;margin-bottom: 15px;" >
                  <select id="listSelect" name="listSelect" class="custom-select" [(ngModel)]="wordlistselect" style="width: 160px;" (change)="onWordlistChange($event)">
                    <option *ngFor="let lista of nombresListas" [value]="lista.id">{{ lista.nombre }}</option>
                  </select>
                </div>
           
            <span style="margin-left: 10px; color: #EEA21A; cursor: pointer; font-weight: 580; text-align: center; align-items: center; "><u style="margin-right: 5px;" (click)="createList()">Create New Known Word List</u><div class="tooltip-container">
              <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
              <span class="tooltip-text2" >
You can create a new set of 'known words' which will be ignored in analysis. This is particularly useful if your text is domain-specific, and certain specific terminology is overrepresented compared to the normal population. For example, if you are teaching a group of doctors who will be more familiar with complex medical terms than the average person. </span>
            </div></span>

          </ng-template>


        </div>
        <div class="box-button">
        <button mat-button class="analysis-button" (click)="closeDialog()"><span class="main-box-title-16" style="font-weight: 600;"> Go To Analysis</span> </button>
        </div>
    </mat-dialog-content>
  </ng-template>
  
